import React, { FC, Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, RouteComponentProps, Switch } from "react-router";
import { Redirect } from "react-router-dom";
import { LoadingContainer } from "go-core/components/Loading";
import { selectOrganization } from "go-security/services/organizations/selectors";
import DocumentsNavigation from "./components/Navigation/DocumentsNavigation";
import { useHasInvoicePermission } from "./hooks/useHasInvoicePermission";
import OrganizationBundlePage from "./pages/Bundle";
import OrganizationDocumentInvoicePage from "./pages/Invoice";
import OrganizationOrderOrderPage from "./pages/Order";
import OrganizationOrderPurchasePage from "./pages/Purchase";
import OrganizationStockAdjustmentPage from "./pages/StockAdjustment";
import OrganizationTransferPage from "./pages/Transfer";

const OrganizationOrderPage: FC<RouteComponentProps> = (props) => {
	const organization = useSelector(selectOrganization);
	const { hasInvoiceBasicPermission } = useHasInvoicePermission();

	return (
		<div className="page-container">
			<Suspense fallback={<LoadingContainer />}>
				<DocumentsNavigation />
			</Suspense>
			<Switch>
				<Route path={`${props.match.url}/purchases`} component={OrganizationOrderPurchasePage} />
				<Route path={`${props.match.url}/sales`} component={OrganizationOrderOrderPage} />
				<Route path={`${props.match.url}/stock_adjustments`} component={OrganizationStockAdjustmentPage} />
				<Route path={`${props.match.url}/bundles`} component={OrganizationBundlePage} />
				{organization.more.stock_count > 1 && (
					<Route path={`${props.match.url}/transfers`} component={OrganizationTransferPage} />
				)}
				<Route path={`${props.match.url}/bundles`} component={OrganizationBundlePage} />
				{hasInvoiceBasicPermission && (
					<Route path={`${props.match.url}/invoices`} component={OrganizationDocumentInvoicePage} />
				)}
				<Redirect from={props.match.url} exact to={`${props.match.url}/purchases`} />
			</Switch>
		</div>
	);
};
export default OrganizationOrderPage;
